import { render, staticRenderFns } from "./AdminPor.vue?vue&type=template&id=399e2295&scoped=true&"
import script from "./AdminPor.vue?vue&type=script&lang=js&"
export * from "./AdminPor.vue?vue&type=script&lang=js&"
import style0 from "./AdminPor.vue?vue&type=style&index=0&id=399e2295&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399e2295",
  null
  
)

export default component.exports